export type Role = 'sv' | 'owner'

export function normalizeRole(value?: string | null): Role {
  const upper = value?.toUpperCase()
  if (upper === 'OWNER') return 'owner'
  return 'sv'
}
